import React from "react";
import FunnelInsightCard from "./FunnelInsightCard";
import { buildRepeatCustomersChart } from "./funnelChartUtils";
import {
  cleanLines,
  extractTitle,
  stripTitleLines,
  extractTableBlock,
  splitByHeading,
  toBullets,
  toParagraphs,
  extractVerdict,
} from "./funnelUtils";

const FunnelRepeatCustomers = ({ markdown = "" }) => {
  const title = extractTitle(markdown) || "Repeat Customers";
  const lines = stripTitleLines(cleanLines(markdown));
  const { table, before, after } = extractTableBlock(lines);
  const chart = buildRepeatCustomersChart(table);
  const { tail } = splitByHeading(after, "What Does This Mean?");
  const bullets = toBullets(tail);
  let paragraphs = toParagraphs(tail);
  const verdict = extractVerdict(paragraphs);
  if (verdict) paragraphs = paragraphs.slice(0, -1);

  return (
    <FunnelInsightCard
      title={title}
      kicker="Retention Signal"
      sections={[
        {
          title: "Customer Return Metrics",
          chart,
          chartTitle: "Repeat Purchase Snapshot",
          chartSubtitle:
            "This turns the retention table into a faster visual read.",
          table,
          paragraphs: before.length ? toParagraphs(before) : [],
        },
        {
          title: "What Does This Mean?",
          bullets,
          paragraphs,
          verdict,
        },
      ]}
    />
  );
};

export default FunnelRepeatCustomers;
